export const GET_LAYOUT_CUTSHEETS = 'GET_LAYOUT_CUTSHEETS'
export const OPEN_ERROR_DIALOG = 'OPEN_ERROR_DIALOG'
export const RESET_CABLING_FORM = 'RESET_CABLING_FORM'
export const CREATE_CABLING_TYPES = 'CREATE_CABLING_TYPES'
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'
export const GET_ACTIVE_SHEETS = 'GET_ACTIVE_SHEETS'
export const GET_WORKSPACES = 'GET_WORKSPACES'
export const DOWNLOAD_LAYOUT = 'DOWNLOAD_LAYOUT'
export const GET_CABLING_COUNTS = 'GET_CABLING_COUNTS'
export const CLEAR_CABLING_COUNTS_STATUS_MESSAGE =
  'CLEAR_CABLING_COUNTS_STATUS_MESSAGE'
